/**
 * PLDV-8952 / GE-7579 — games blocked per US state.
 *
 * The customer's state is `location.state` from the last GetAccountInfoResponse
 * (saved to `appConfig.location` for both the success and the error flow), so the
 * block follows the backend's IP/GPS-derived location, not the KYC address.
 *
 * Codes are matched against `GameProduct.code`, which is present on every payload,
 * swimlane products included. Codes of currently disabled games stay listed on
 * purpose: re-enabling a game in the catalogue must not silently lift its block.
 */

/** Koala games blocked in Florida (GE-7579). */
const FLORIDA_BLOCKED_GAME_CODES: readonly string[] = [
  'kg_5001', // Voltage Blitz Vortex
  'kg_5006', // 3 Big Barrels Buffalo (94%)
  'kg_5505', // 3 Big Barrels Buffalo (96%)
  'kg_5529', // Voltage Blitz Rapid (92%)
  'kg_5009', // Voltage Blitz Rapid (94%)
  'kg_5517', // 3 Big Barrels Aztec (96%)
  'kg_5007', // 3 Big Barrels Aztec (94%)
  'kg_5527', // Voltage Blitz Zeus Up (96%)
  'kg_5016', // Voltage Blitz Zeus Up (94%)
  'kg_5039', // Voltage Blitz Stars 'N' Stripes
  'kg_5065', // Triple Stash Stampede
  'kg_5064', // Triple Stash Inca
  'kg_5063', // Turbo Storm Typhoon
  'kg_5054', // Turbo Storm Tempest
  'kg_5062', // Turbo Storm Dragon Up
]

export const GEO_BLOCKED_GAME_CODES_BY_STATE: Readonly<Record<string, readonly string[]>> = {
  FL: FLORIDA_BLOCKED_GAME_CODES,
}

const GEO_BLOCKED_CODE_SETS_BY_STATE = new Map(
  Object.entries(GEO_BLOCKED_GAME_CODES_BY_STATE).map(([state, codes]) => [
    state,
    new Set(codes) as ReadonlySet<string>,
  ]),
)

/**
 * Blocked game codes for a state, or `null` when nothing is blocked there.
 * Returns a stable Set per state so selectors and memo hooks can compare by reference.
 */
export const getGeoBlockedGameCodes = (state?: string | null): ReadonlySet<string> | null => {
  if (!state) {
    return null
  }

  return GEO_BLOCKED_CODE_SETS_BY_STATE.get(state.trim().toUpperCase()) ?? null
}
